import StepLabel from '@mui/material/StepLabel';

export default StepLabel;